import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import ConsultationModal from '../components/ConsultationModal';

const Coaches = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="min-h-screen bg-white">
      <Navbar setIsModalOpen={setIsModalOpen} />
      <ConsultationModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
      <main className="container mx-auto px-4 py-20">
        <h1 className="text-4xl font-bold text-center text-brand-dark mb-12">教练团队</h1>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="card">
            <img src="/images/coach-1.jpg" alt="教练头像" className="w-32 h-32 rounded-full mx-auto mb-6" />
            <h2 className="text-2xl font-bold text-center text-brand-dark mb-4">张教练</h2>
            <p className="text-brand-text text-center mb-4">ICF认证教练，10年教练经验</p>
            <p className="text-brand-text">
              专注于领导力发展和团队建设，帮助客户实现个人和组织的持续成长。
            </p>
          </div>
          <div className="card">
            <img src="/images/coach-2.jpg" alt="教练头像" className="w-32 h-32 rounded-full mx-auto mb-6" />
            <h2 className="text-2xl font-bold text-center text-brand-dark mb-4">李教练</h2>
            <p className="text-brand-text text-center mb-4">ICF认证教练，8年教练经验</p>
            <p className="text-brand-text">
              专注于职业发展规划和个人效能提升，帮助客户找到职业发展的新方向。
            </p>
          </div>
          <div className="card">
            <img src="/images/coach-3.jpg" alt="教练头像" className="w-32 h-32 rounded-full mx-auto mb-6" />
            <h2 className="text-2xl font-bold text-center text-brand-dark mb-4">王教练</h2>
            <p className="text-brand-text text-center mb-4">ICF认证教练，12年教练经验</p>
            <p className="text-brand-text">
              专注于组织文化转型和领导力发展，帮助客户建立高效的组织文化。
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Coaches; 